import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

const MantComponent = ({mant, idEdit, createData, updateData, closeSection, componentes, idRef, setIdRef, endPointShow, setEndPointUpdate, init, showCreate, showEdit}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);
    const [isMenu, setIsMenu] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init()
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }
    }, [location.pathname]);

    const onSubmit1 = (form) => {
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(form);
        } else {
            updateData(form);
        }
    };

    const validaTipoComponente = (event) => {
        let value = event.target.value
        setIsMenu(value == CONFIGURACIONES.INIT.TYPE_SUB_MENU?CONFIGURACIONES.INIT.STATUS_TRUE:CONFIGURACIONES.INIT.STATUS_FALSE)
        setValue('componenteReferenciadoId', '');
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            // console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const loadForm = (object) => {
        setValue('nombre', object.nombre);
        setValue('orden', object.orden);
        setValue('nivel', object.nivel);
        setValue('enlaceInterno', object.enlaceInterno);
        setValue('icono', object.icono);
        setValue('idInterno', object.idInterno);
        setValue('tipoComponente', object.tipoComponente);

        let isStatusMenu = object.tipoComponente == CONFIGURACIONES.INIT.TYPE_SUB_MENU?CONFIGURACIONES.INIT.STATUS_TRUE:CONFIGURACIONES.INIT.STATUS_FALSE
        setIsMenu(isStatusMenu)

        if (isStatusMenu) {
            setValue('componenteReferenciadoId', object.componenteReferenciadoId);
        }
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="orden" className="control-label col-form-label">Orden <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("orden", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER_TINYINT,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="orden" placeholder="" />
                                        <small className="invalid-feedback"> { errors.orden && errors.orden.message }</small>           
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="nivel" className="control-label col-form-label">Nivel <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("nivel", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="nivel" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                CONFIGURACIONES.INIT.LIST.NIVEL.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.nivel && errors.nivel.message }</small>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="enlaceInterno" className="control-label col-form-label">Enlace Interno <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("enlaceInterno", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="enlaceInterno" placeholder="" />
                                        <small className="invalid-feedback"> { errors.enlaceInterno && errors.enlaceInterno.message }</small>           
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="icono" className="control-label col-form-label">Icono <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("icono", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="icono" placeholder="" maxLength={30} />
                                        <small className="invalid-feedback"> { errors.icono && errors.icono.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="idInterno" className="control-label col-form-label">ID Interno <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("idInterno", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ID_INTERNO,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="idInterno" placeholder="" maxLength={10} />
                                        <small className="invalid-feedback"> { errors.idInterno && errors.idInterno.message }</small>           
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoComponente" className="control-label col-form-label">Tipo Componente <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoComponente", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    validaTipoComponente(e)
                                                }
                                            })} className="form-control" id="tipoComponente" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPO_COMPONENTE.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoComponente && errors.tipoComponente.message }</small>
                                    </div>
                                </div>

                                {isMenu && <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="componenteReferenciadoId" className="control-label col-form-label">Componente Padre <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("componenteReferenciadoId", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="componenteReferenciadoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                componentes.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.componenteReferenciadoId && errors.componenteReferenciadoId.message }</small>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantComponent;